import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {LatestPlatesWrapper} from './LatestPlatesWrapper.js'
import {MediaVideoWrapper} from './MediaVideoWrapper.js'
import {SingleImage} from './SingleImage.js'

const NO_COMPONENT = () => null

export const EmbeddedEntriesDispatcher = ({
  entryContent,
  customContentConfig,
  professionalSellerAds,
  professionalSellerAdsListingUrl,
  vehicles
}) => {
  const {domain} = useContext(Context)
  const {
    NEWS_EMBEDDED_ENTRY_TYPE_IMAGE_SINGLE,
    NEWS_EMBEDDED_ENTRY_TYPE_YOUTUBE_VIDEO,
    NEWS_EMBEDDED_ENTRY_TYPE_LATEST_PLATES,
    NEWS_EMBEDDED_ENTRY_TYPE_DEFAULT
  } = domain.get('config').get('COMMON')
  const CONTENT_CONFIG_FALLBACK = {
    entryType: NEWS_EMBEDDED_ENTRY_TYPE_DEFAULT,
    entryInfo: {}
  }

  const entryId = entryContent.data.target.sys.id
  const {entryType, entryInfo} = customContentConfig[entryId] || CONTENT_CONFIG_FALLBACK

  const componentsByTypes = {
    [NEWS_EMBEDDED_ENTRY_TYPE_IMAGE_SINGLE]: entryInfo => <SingleImage {...entryInfo} />,
    [NEWS_EMBEDDED_ENTRY_TYPE_YOUTUBE_VIDEO]: entryInfo => (
      <MediaVideoWrapper
        entryInfo={entryInfo}
        professionalSellerAds={professionalSellerAds}
        professionalSellerAdsListingUrl={professionalSellerAdsListingUrl}
        vehicles={vehicles}
      />
    ),
    [NEWS_EMBEDDED_ENTRY_TYPE_LATEST_PLATES]: entryInfo => <LatestPlatesWrapper {...entryInfo} />,
    [NEWS_EMBEDDED_ENTRY_TYPE_DEFAULT]: NO_COMPONENT
  }

  return componentsByTypes[entryType](entryInfo)
}

EmbeddedEntriesDispatcher.propTypes = {
  entryContent: PropTypes.object,
  customContentConfig: PropTypes.object
}
